<template>
<div id="customerBatchManagement">
  <div class="container" id="customerBatchManagement-container">
    <div class="table-responsive mt-1" id="customerBatchManagement-tableDiv">
      <table class="table table-striped table-hover" id="customerBatchManagement-table">
        <caption class="accessibly-hidden">{{ 'CUSTOMER_BATCH_MANAGEMENT' | translate }}</caption>
        <template v-if="filteredBatches.length > 0">
          <tr class="d-lg-flex" id="customerBatchManagement-tableRow">
            <th scope="col" class="col-lg-3"></th>
            <th scope="col" class="col-lg-6">{{ 'COUNT' | translate }}</th>
            <th scope="col" class="col-lg-3"></th>
          </tr>
          <tbody id="customerBatchManagement-tableBody">
              <tr v-for="(group, batchIdKey) in groupedBatches" class="d-lg-flex" :id="'customerBatchManagement-tableBody-'+batchIdKey">
                <td class="col-lg-3" :id="'customerBatchManagement-tableBody-data-'+batchIdKey">
                  <div class="custom-control alternative custom-checkbox" :id="'customerBatchManagement-tableBody-checkboxDiv-'+batchIdKey">
                    <input class="custom-control-input" type="checkbox"
                           :id="'checkbox_' + batchIdKey" :value="group" v-model="selected">
                    <label class="custom-control-label" :for="'checkbox_' + batchIdKey" :id="'customerBatchManagement-tableBody-checkbox-label-'+batchIdKey"> {{ batchIdKey }} </label>
                  </div>
                </td>
                <td class="col-lg-6">{{ group.count }}</td>
                <td class="col-lg-3">
                  <small v-if="underDeletion(batchIdKey).inQueue">
                    <span v-if="underDeletion(batchIdKey).status === 'RUNNING'" class="text-danger">
                      <i class="fa fa-refresh fa-spin mr-1" aria-hidden="true"></i> {{ 'DELETING' | translate }}
                    </span>
                    <span v-else class="text-info">{{ 'PENDING_DELETE' | translate }}</span>
                  </small>
                </td>
              </tr>
          </tbody>
        </template>
      </table>
    </div>
    <div v-if="filteredBatches.length === 0" class="text-center mt-4" id="customerBatchManagement-noBatchFoundDiv">{{ 'NO_BATCHES_FOUND' | translate }}</div>
  </div>
</div>
</template>

<script>
import RestService from '../../service/RestService.js';
import { Roles } from '../../service/keycloak/Roles';

export default {
  components: {},
  props: [ 'jobs', 'batchFilter' ],
  data: function() {
    return {
      rest: this.initRestService(),
      roles: Roles,
      batches: [],
      deletingBatchesIds: [],
      selected: [],
      interval: null
    }
  },
  beforeMount() {
    this.init();
  },
  mounted() {
    this.$emit('set-active-component', 'CUSTOMER_BATCH_MANAGEMENT');
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.interval);
    next();
  },
  computed: {
    actionsAndAllowedRoles() {
      return {
        'delete_customers': [ this.roles.ADMIN, this.roles.BATCH_DELETE ]
      }
    },
    filteredBatches() {
      if (this.batchFilter == null || this.batchFilter.length < 1) return this.batches;
      return this.batches.filter(val => {
        return (val.batchId) ? val.batchId.toLowerCase().indexOf(this.batchFilter.toLowerCase()) >= 0 : false;
      });
    },
    groupedBatches() {
      let groups = {};
      this.filteredBatches.forEach((row) => {
        if (!row['batchId']) {
          if (!groups['_']) {
            groups['_'] = {};
          }
          groups['_'] = row;
          return;
        }
        if (!groups[row.batchId]) {
          groups[row.batchId] = {};
        }
        groups[row.batchId] = row;
      });
      return groups;
    },
    runningBatchesExist() {
      return this.deletingBatchesIds.length;
    }
  },
  methods: {
    initRestService: function() {
      return new RestService();
    },
    underDeletion: function(batchIdKey) {
      if (this.deletingBatchesIds.indexOf(batchIdKey) >= 0) {
        let currentJob = this.jobs.find(
          job => (batchIdKey === job.batchId) && (job.type === 'DELETE_CUSTOMERS')
        );
        if (currentJob) {
          return { inQueue: true, status: currentJob.status };
        }
      }
      return { inQueue: false };
    },
    init: function() {
      this.getBatches();
    },
    getBatches: async function() {
      const res = await this.rest.getCustomerBatches();
      this.batches = res.data;
    },
    poll: async function() {
      let changeDetected = this.checkForDeleteChanges();
      if (changeDetected) {
        this.getBatches();
      }
    },
    getSelectedBatchesForDelete: function() {
      this.selected.forEach(selectedBatch => {
        if (selectedBatch.batchId === null || selectedBatch.batchId === '') selectedBatch.batchId = '_';
        this.deletingBatchesIds.push(selectedBatch.batchId)
      });
      return this.selected;
    },
    checkForDeleteChanges() {
      const initialSize = this.deletingBatchesIds.length;

      const arraysOfDeletingAndDeleted = this.deletingBatchesIds.reduce((acc, batchId) => {
        (this.jobs.some(job => (job.batchId) === batchId))
          ? acc.stillDeleting.push(batchId) : acc.alreadyDeleted.push(batchId);
        return acc;
      }, {stillDeleting: [], alreadyDeleted: []});

      this.deletingBatchesIds = arraysOfDeletingAndDeleted.stillDeleting;

      this.selected = this.selected.filter(batch => (
        arraysOfDeletingAndDeleted.alreadyDeleted.indexOf(batch.batchId) < 0));

      return initialSize !== this.deletingBatchesIds.length;
    },
    selectAllBatches() {
      this.selected = this.batches;
    },
    deselectAllBatches() {
      this.selected = [];
    }
  },
  watch: {
    selected(newVal) {
      if (newVal.length === 0) {
        this.$emit('update-allselected', false, false);
      } else if (newVal.length === this.batches.length) {
        this.$emit('update-allselected', true, false);
      } else {
        this.$emit('update-allselected', true, true);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/batch/CustomerBatchManagement.vue